import theme from 'config/theme';

export default {
  asidePanel: {
    width: theme.customValues.taskSidebarWidth,
    minWidth: theme.customValues.taskSidebarWidth,
    flexShrink: 0,
    position: 'relative',
  },
  asideContainer: {
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    height: '100%',
    overflow: 'auto',
    boxSizing: 'border-box',
    '> *': { flexShrink: 0 },
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '4px',
  },
  fieldValueContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  row: {
    display: 'flex',
    gap: '4px',
    flexDirection: 'column',
  },
  sectionHeaderContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  sectionTitle: {
    fontSize: '20px',
    fontWeight: 600,
    color: theme.palette.grays.gray700,
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    justifyContent: 'flex-start',
  },
  fieldLabel: {
    fontWeight: 500,
    fontSize: '0.875rem',
    color: theme.palette.grays.gray500,
  },
  fieldLabelWithIcon: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '10px',
  },
  fieldValue: {
    color: theme.palette.grays.gray600,
    fontSize: '16px',
    display: 'block',
  },
  addressContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  addressLink: {
    textDecoration: 'none',
    flex: 1,
  },
  addressText: {
    fontSize: '16px',
    color: theme.palette.blues.primaryBlue500,
    ':hover': {
      textDecoration: 'underline',
    },
  },
  editButton: {
    color: theme.palette.blues.primaryBlue500,
    p: 0.5,
  },
  bankContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  bankText: {
    fontSize: '16px',
    color: theme.palette.grays.gray900,
    flex: 1,
  },
  ibanText: {
    fontSize: '16px',
    color: theme.palette.grays.gray900,
    wordBreak: 'break-all',
    flex: 1,
  },
  divider: {
    height: '1px',
    backgroundColor: theme.palette.grays.gray200,
    my: 1,
  },
  contactSectionHeader: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '4px',
  },
  contactSectionTitle: {
    fontSize: '18px',
    fontWeight: 600,
    color: theme.palette.grays.gray700,
  },
  contactContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    justifyContent: 'flex-start',
  },
  contactItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    mb: 0.5,
  },
  contactText: {
    fontSize: '16px',
    color: theme.palette.grays.gray900,
  },
  contactPhoneText: {
    fontSize: '16px',
    color: theme.palette.blues.primaryBlue500,
  },
  contactEmailText: {
    fontSize: '16px',
    color: theme.palette.blues.primaryBlue500,
    wordBreak: 'break-all',
  },
  primaryChip: {
    backgroundColor: theme.palette.violets.violet200,
    color: theme.palette.violets.violet900,
    fontSize: '12px',
    height: '20px',
  },
  editContactIcon: {
    fontSize: '16px',
    color: theme.palette.blues.primaryBlue500,
  },
  copyButton: {
    padding: '6px',
    '.copy-icon': {
      width: '18px',
      height: '18px',
    },
    ':hover': {
      '.copy-icon-path': {
        stroke: theme.palette.primary.main,
      },
    },
  },
  callButton: {
    padding: '6px',
    '.phone-icon': {
      width: '18px',
      height: '18px',
    },
    '&:hover': {
      '.phone-icon-path': {
        fill: theme.palette.primary.main,
      },
    },
  },
};
